import { Media } from './media'
import { Metafield } from './metafield'
import { Variant } from './variant'

export interface ProductOptions {
  id?: string
  handle?: string
  locale?: string
  globalHandle?: string
  pimSyncSourceDomain?: string
  pimSyncSource?: string
  pimSyncSourceProductId?: string
  title?: string
  description?: string
  priceRange?: PriceRange
  productType?: string
  featuredMedia?: Media
  availableForSale?: boolean
  vendor?: string
  tags?: Array<string>
  media?: Array<Media>
  metafields?: Array<Metafield>
  variants?: Array<Variant>
  createdAt?: number
  updatedAt?: number
  indexedAt?: number
}

interface PriceRange {
  min: string
  max: string
  currencyCode: string
}

export interface Product {
  id: string
  handle: string
  locale: string
  globalHandle: string
  pimSyncSourceDomain: string
  pimSyncSource?: string
  pimSyncSourceProductId?: string
  title: string
  description: string
  priceRange: PriceRange
  productType?: string
  featuredMedia?: Media
  availableForSale: boolean
  vendor?: string
  tags: Array<string>
  media: Array<Media>
  metafields: Array<Metafield>
  variants: Array<Variant>
  createdAt?: number
  updatedAt?: number
  indexedAt: number
}

export const createProduct = (options: ProductOptions): Product => {
  const product: Product = {
    id: '',
    handle: '',
    locale: 'en-us',
    globalHandle: '',
    pimSyncSourceDomain: '',
    title: '',
    description: '',
    priceRange: {
      min: '0.0',
      max: '0.0',
      currencyCode: 'USD'
    },
    availableForSale: true,
    tags: [],
    media: [],
    metafields: [],
    variants: [],
    indexedAt: 0,
    ...options
  }

  return product
}
